<div class="register-layout" *ngIf="bankAssigned">
  <div class="row form-layout py-4">
    <div class="col-md-10 form position-relative mb-5">
      <div class="row">
        <div class="col-4 mt-1">
          <div class="form-label ">
            <h2 class="dashboard-sub-heading">Add Bank Account</h2>
          </div>

        </div>
        <div class="col-7">
          <div class="form-label mt-1">
            <button type="button" class="btn btn-primary btn-md btn-floating custom-icon-button1"
                    (click)="openAddBankAccModal()">
            </button>
          </div>
        </div>
        <hr>
      </div>
      <p class="form-label" style="color: red;" *ngIf="showError">
        <i class="bi bi-info-circle" ></i>
        Add atleast one bank account to proceed
      </p>
    </div>

    <div class="col-md-10" *ngIf="!isTableEmptyBank">
      <table class="table align-middle mb-0 bg-white table-lg" [ngClass]="loading ? 'blur-background' : ''">
        <thead class="bg-light">
        <tr>
          <th>Account Number</th>
          <th>Bank Name</th>
          <th>Currency</th>
          <th> Is Default</th>
          <th>Action</th>
        </tr>
        </thead>
        <div *ngIf="loading" class="text-center position-absolute top-50 start-50 " style="z-index: 10000;">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <tbody  *ngFor="let bankAcc of bankDetails?.['bankAccountList']">
        <tr>
          <td>
            <p class="fw-normal mb-1">{{bankAcc.bankAccountNumber}}</p>
          </td>
          <td>
            <p class="fw-normal mb-1">{{bankAcc.bankName}}</p>
          </td>
          <td>
            <p class="fw-normal mb-1">{{bankAcc.currency}}</p>
          </td>
          <td>
            <div class="form-check">
              <input
                mdbCheckbox
                [disabled]="true"
                class="form-check-input"
                type="checkbox"
                [checked]="bankAcc.isDefault == '1' ? true : false"
                value="1"
                id="flexCheckDefault"
              />
            </div>
          </td>

          <td>
            <button type="button" class="btn btn-link btn-sm btn-rounded" (click)="openEditBankAccModal(bankAcc)">
              Edit
            </button>
          </td>
          <!-- <td>
              <button type="button" class="btn btn-link btn-sm btn-rounded">
                  Remove
              </button>
          </td> -->
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
